export default "__VITE_ASSET__DUwUQ4QE__"